import React from 'react';
import {
  Box,
  Inscription,
  Status,
  TextWithPointer,
} from '@common-fe/common-fe';
import { BasisType } from 'grommet/utils';
import { capitalize } from 'lodash';
import styled from 'styled-components';

import { EmployeeStatus } from '@/modules/employee/employee.constants';

const StatusWrapper = styled(Box)`
  .status-circle {
    max-width: 10px;
    max-height: 10px;
    min-width: 10px;
    min-height: 10px;
  }
  .status-text {
    font-weight: bold;
    line-height: 20px;
    margin-left: ${({ theme }) => theme.spacings.spacing4};
  }
`;

interface Props {
  isBold?: boolean;
  head?: string;
  title?: string;
  status?: EmployeeStatus;
  basis?: BasisType;
}

const TileCell: React.FC<Props> = ({ head, title, status, isBold, basis = '1/3' }) => (
  <Box basis={basis}>
    <Inscription color="textSecondary" size="small" lineHeight="18px" weight={500}>{head}</Inscription>
    {title ? (
      <TextWithPointer
        {...isBold ? { weight: 'bold' } : {}}
        color="textBody"
        style={{ fontWeight: '20px' }}
        ellipsisMode
        title={title}
      >
        {title}
      </TextWithPointer>
    ) : null}
    {status ? (
      <StatusWrapper direction="row">
        <Status testId={`TileCell_status_${status}`} status={capitalize(status)} ellipsisMode />
      </StatusWrapper>
    ) : null}
  </Box>
);

export default TileCell;
